import { memo } from 'util/memoizationUtils';
import BackendService from './BackendService';

export default class AccessoryConfigService {
  static getAccessoryConfig(dealerId) {
    return BackendService.get(`/accessoryConfigs/${dealerId}`);
  }

  static memoizedGetAccessoryConfig = memo(this.getAccessoryConfig);

  static updateAccessoryConfig(dealerId, accessoryConfig) {
    return BackendService.put(`/accessoryConfigs/${dealerId}`, {
      body: accessoryConfig,
    });
  }

  static updateAccessory(dealerId, accessoryId, formData) {
    return BackendService.put(
      `/accessoryConfigs/${dealerId}/accessory/${accessoryId || ''}`,
      { formData },
      true,
    );
  }
  static getInsigniaEnabledMakes() {
    return BackendService.get('/accessoryConfigs/insigniaEnabledMakes');
  }
}
